import React from "react";
import styles from "./DoctorsMessage.module.css";
import AuxiliaryWaves from "../../../../components/UI/AuxiliaryWaves";
import DoctorsMessagePattern from "../../../../components/UI/DoctorsMessagePattern";
import DoctorsMessagePatternTab from "../../../../components/UI/DoctorsMessagePatternTab";
import DoctorsMessagePatternMob from "../../../../components/UI/DoctorsMessagePatternMob";
import useDeviceWidth from "../../../../components/device-width/UseDeviceWidth";

const DoctorsMessage = ({ data }) => {
  const width = useDeviceWidth();

  return (
    <section className={styles.section}>
      {/* <img
        className={styles.pattern}
        src="https://via.placeholder.com/1200x800/000000/333333?text=Pattern"
        alt="Pattern"
      /> */}
      {width > 1200 ? (
        <DoctorsMessagePattern className={styles.pattern} />
      ) : width > 768 ? (
        <DoctorsMessagePatternTab className={styles.pattern} />
      ) : (
        <DoctorsMessagePatternMob className={styles.pattern} />
      )}
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img
            data-aos="fade-down"
            data-aos-delay="150"
            className={styles.mainImage}
            src={data?.listingItems[0]?.images[0]?.url}
            alt={data?.listingItems[0]?.images[0]?.imageTag}
          />
        </div>
        <div className={styles.content}>
          <h2
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.subtitle}
          >
            {data?.subTitle}
          </h2>
          {data?.showTitle && (
            <div className={styles.title}>
              <h2
                dangerouslySetInnerHTML={{ __html: data?.title }}
                data-aos="fade-right"
                data-aos-delay="150"
              ></h2>
            </div>
          )}
          <div
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: data?.listingItems[0]?.homeDescription,
            }}
          />
          {/* <button
            className={`${styles.button} bg-primary-500 primary-hover2 border-primary-500`}
          >
            Know More
          </button> */}
        </div>
      </div>
    </section>
  );
};

export default DoctorsMessage;
